import {
  Input,
  Output,
  Component,
  EventEmitter,
  HostBinding,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-burger-menu',
  templateUrl: './burger-menu.component.html',
  styleUrls: ['./burger-menu.component.scss'],
})
export class BurgerMenuComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'mobile-button-component';
  public isMenuCollapsed: boolean;
  public subscription: Subscription;

  @Input() public isPrimary: boolean;
  @Output() public toggled: EventEmitter<boolean>;

  constructor(private router: Router) {
    this.isPrimary = false;
    this.isMenuCollapsed = true;
    this.toggled = new EventEmitter<boolean>();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.subscription = this.router.events.subscribe(event => {
      const isNavigationEnd = event instanceof NavigationEnd;

      if (isNavigationEnd) {
        this.isMenuCollapsed = true;
        this.toggled.emit(false);
      }
    });
  }

  toggle(): void {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this.toggled.emit(!this.isMenuCollapsed);
  }
}
